import { IconProps } from "./types";

export const InvalidIcon: React.FC<IconProps> = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <path
        d="M8.5625 14.2227C7.7325 14.2227 6.9525 14.0652 6.2225 13.7502C5.4925 13.4352 4.8575 13.0077 4.3175 12.4677C3.7775 11.9277 3.35 11.2927 3.035 10.5627C2.72 9.83266 2.5625 9.05266 2.5625 8.22266C2.5625 7.39266 2.72 6.61266 3.035 5.88266C3.35 5.15266 3.7775 4.51766 4.3175 3.97766C4.8575 3.43766 5.4925 3.01016 6.2225 2.69516C6.9525 2.38016 7.7325 2.22266 8.5625 2.22266C9.3925 2.22266 10.1725 2.38016 10.9025 2.69516C11.6325 3.01016 12.2675 3.43766 12.8075 3.97766C13.3475 4.51766 13.775 5.15266 14.09 5.88266C14.405 6.61266 14.5625 7.39266 14.5625 8.22266C14.5625 9.05266 14.405 9.83266 14.09 10.5627C13.775 11.2927 13.3475 11.9277 12.8075 12.4677C12.2675 13.0077 11.6325 13.4352 10.9025 13.7502C10.1725 14.0652 9.3925 14.2227 8.5625 14.2227ZM8.5625 13.0227C9.1025 13.0227 9.6225 12.9352 10.1225 12.7602C10.6225 12.5852 11.0825 12.3327 11.5025 12.0027L4.7825 5.28266C4.4525 5.70266 4.2 6.16266 4.025 6.66266C3.85 7.16266 3.7625 7.68266 3.7625 8.22266C3.7625 9.56266 4.2275 10.6977 5.1575 11.6277C6.0875 12.5577 7.2225 13.0227 8.5625 13.0227ZM12.3425 11.1627C12.6725 10.7427 12.925 10.2827 13.1 9.78266C13.275 9.28266 13.3625 8.76266 13.3625 8.22266C13.3625 6.88266 12.8975 5.74766 11.9675 4.81766C11.0375 3.88766 9.9025 3.42266 8.5625 3.42266C8.0225 3.42266 7.5025 3.51016 7.0025 3.68516C6.5025 3.86016 6.0425 4.11266 5.6225 4.44266L12.3425 11.1627Z"
        fill="#999999"
        stroke="#999999"
        stroke-width="0.4"
      />
    </svg>
  );
};
